import calls from "./calls";
import notifications from "./notifications";
import scheduled from "./scheduled";
import services from "./services";
import version from "./version";

const modules = [calls, services, version, notifications, scheduled];
export const subscribe = () => {
  modules.forEach((m) => {
    window.$bus.subscribe(m);
  });
};
